<svg role="img" class="animate-spin w-4 h-4" viewBox="0 0 100 100">
  <circle class="animate-spin" r="100" cx="50" cy="50"></circle>
</svg>
